export const getMobileMenuRootSelector = (state) => state.mobileMenu;
export const getMobileMenuIsOpenSelector = (state) => getMobileMenuRootSelector(state).isMobileMenuOpen;
